import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge, extended by the DELABO Lib tokens so `text-h3` is a font size (not a colour)
 * and `shadow-modal` / `rounded-tile` take part in conflict resolution.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['h1', 'h2', 'h3', 'h4', 'body', 'title', 'table', 'caption'] }],
      shadow: [{ shadow: ['popover', 'modal', 'savebar', 'tile'] }],
      rounded: [{ rounded: ['tile'] }],
    },
  },
});

/** Merges class names and resolves Tailwind class conflicts (last one wins). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
